import PropTypes from 'prop-types'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'

import colors from 'components/utils/colors'

const StyledOtherItems = styled.div`
  color: ${colors.primary40};
  white-space: nowrap;
  cursor: pointer;
`

const OtherItems = ({ itemsCount, onClick, maxDisplayItems }) => {
  const { t } = useTranslation()

  let otherItemsText
  if (maxDisplayItems && itemsCount > maxDisplayItems) {
    const otherItemsCount = itemsCount - maxDisplayItems
    otherItemsText = t('common.multiSelectItemCount', { count: otherItemsCount })
  }
  if (!otherItemsText) {
    return null
  }

  return (
    <StyledOtherItems onClick={onClick}>{otherItemsText}</StyledOtherItems>
  )
}

OtherItems.propTypes = {
  itemsCount: PropTypes.number,
  onClick: PropTypes.func,
  maxDisplayItems: PropTypes.number,
}

export default OtherItems
